export class MyPortfolioSideNavigationTree {
    static topItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'MY_COMMUNITIES',
            path: '/my-portfolio/my-communities',
            icon: '',
            text: 'My Communities',
            tooltip: 'My Communities',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'MY_COMMUNITIES_MAP',
            path: '/my-portfolio/my-communities-map',
            icon: '',
            text: 'Map of My Communities',
            tooltip: 'Map of My Communities',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'USER_CLOUD_DRIVE',
            path: '/my-portfolio/cloud-drive',
            icon: '',
            text: 'Cloud Drive',
            tooltip: 'Cloud Drive',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'VENDOR_MANAGEMENT',
            path: '/my-portfolio/vendor-management',
            icon: '',
            text: 'Vendor Management',
            tooltip: 'Vendor Management',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_RM',
            path: null,
            icon: '',
            text: 'Revenue Management',
            tooltip: 'Revenue Management',
            items: MyPortfolioSideNavigationTree.topRMItems(`${parentId}_5`)
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'TIME_AND_EXPENSE',
            path: null,
            icon: '',
            text: 'Time & Expense',
            tooltip: 'Time And Expense',
            items: [
                {
                    id: `${parentId}_6_1`,
                    parentId: `${parentId}_6`,
                    name: 'TIME_AND_EXPENSE_MANAGEMENT',
                    path: '/gcb/te/time-and-expense-management',
                    icon: '',
                    text: 'Time & Expense Management',
                    tooltip: 'Time And Expense Management',
                    items: []
                },
                {
                    id: `${parentId}_6_2`,
                    parentId: `${parentId}_6`,
                    name: 'TIME_AND_EXPENSE_SUBMISSION',
                    path: '/gcb/te/time-and-expense-management/submission',
                    icon: '',
                    text: 'Time & Expense Submission',
                    tooltip: 'Time And Expense Submission',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'MY_TESTS',
            path: '/my-portfolio/my-tests',
            icon: '',
            text: 'My Tests',
            tooltip: 'My Tests',
            openInNewWindow: true,
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'ACHIEVEMENTS',
            path: '/my-portfolio/achievements',
            icon: '',
            text: 'Achievements',
            tooltip: 'Achievements',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'ACCOUNT_MANAGEMENT',
            path: '/my-portfolio/account-management',
            icon: '',
            text: 'Account Management',
            tooltip: 'Account Management',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'MY_TEXT',
            path: '/my-portfolio/my-text',
            icon: '',
            text: 'My Text',
            tooltip: 'My Text',
            openInNewWindow: true,
            items: []
        },
        {
            id: `${parentId}_11`,
            parentId,
            name: 'TEST_PLAN_CONFIGURATION',
            path: '/my-portfolio/test-plan-configuration',
            icon: '',
            text: 'Test Plan Configuration',
            tooltip: 'Test Plan Configuration',
            items: []
        },
        {
            id: `${parentId}_12`,
            parentId,
            name: 'TEST_CONFIGURATION',
            path: '/my-portfolio/testing-config',
            icon: '',
            text: 'Testing Configuration',
            tooltip: 'Testing Configuration',
            items: []
        }
    ];

    static topRMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'RM_BILLING_ITEM_MANAGEMENT',
            path: 'my-portfolio/gcb/rm/billingitem',
            icon: '',
            text: 'Billing Item Management',
            tooltip: 'Billing Item Management',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'RM_BILLING_QUEUE_MANAGEMENT',
            path: 'my-portfolio/gcb/rm/billingqueue',
            icon: '',
            text: 'Billing Queue Management',
            tooltip: 'Billing Queue Management',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_RM_MY_CUSTOMER_CHARGES',
            path: 'my-portfolio/gcb/rm/mycustomercharges',
            icon: '',
            text: 'My Customer Charges',
            tooltip: 'My Customer Charges',
            items: []
        }
    ];
}
